module.exports = __webpack_public_path__ + "static/media/Cotisations2.c5fe7308.pdf";